import { Auth } from '@aws-amplify/auth';
import { getEnv } from '@smile-next/uikit';

const env = getEnv();
Auth.configure(env.auth);
